module.exports = __webpack_public_path__ + "assets/img/delete1.182cac46.svg";